import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { HomePage } from "../../home/home";
import { SplitViewPage } from "../split-view/split-view";


@Component({
    selector: 'page-licence-ok',
    templateUrl: 'licence-ok.html'
})

export class LicenceOkPage {

    constructor(private navCtrl: NavController) {

    }

    public ionViewDidEnter () {
        setTimeout(async () => {
            await this.navCtrl.setRoot(SplitViewPage, { leftPane: HomePage });
        }, 3000);
    }

}



// WEBPACK FOOTER //
// ./src/pages/desktop/licence-ok/licence-ok.ts